import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';

const PopUpCustomFieldSelector = ({ selectedCustomFields, onApply, fieldsOptions }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [open, setOpen] = useState(false);

  const handleChange = (_, newValue) => {
    setSelectedOptions(newValue);
  };

  const toggleModalOpen = () => setOpen((prev) => !prev);

  const handleApply = () => {
    onApply(selectedOptions);
    setSelectedOptions([]);
    toggleModalOpen();
  };

  const handleClear = () => {
    toggleModalOpen();
  };

  const handleModalOpen = () => {
    setOpen(true);
    setSelectedOptions([]);
    setSelectedOptions(selectedCustomFields);
  };

  const getOptionLabel = ({ name }) => name || '';

  const getIsOptionsEqual = (option, value) => option.name === value.name;

  return (
    <Box>
      <Button
        onClick={handleModalOpen}
        variant="outlined"
        sx={{ marginBottom: 2 }}
      >
        Select custom fields
      </Button>
      <Dialog open={open}>
        <DialogTitle variant="h4">
          <Typography gutterBottom >
            Choose Fields
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ width: '600px' }}>
          <Autocomplete
            multiple
            disableClearable
            filterSelectedOptions
            value={selectedOptions}
            onChange={handleChange}
            options={fieldsOptions}
            isOptionEqualToValue={getIsOptionsEqual}
            getOptionLabel={getOptionLabel}
            renderInput={(params) => (
              <TextField {...params} autoFocus variant="outlined" />
            )}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClear}>Cancel</Button>
          <Button onClick={handleApply}>Apply</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

const { array, func } = PropTypes;

PopUpCustomFieldSelector.propTypes = {
  onApply: func,
  selectedCustomFields: array,
  fieldsOptions: array,
};

export default PopUpCustomFieldSelector;
